import { LoaderCircleIcon } from "lucide-react"
import logo from '@/assets/logo.png'

export default function Splash({ children }) {
    return (
        <div className="w-screen relative flex h-screen flex-col items-center justify-center items-center">
            <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px] relative bottom-16">
                <div className="flex flex-col space-y-2 text-center">
                    <div className="select-none relative z-20 flex items-center text-center justify-center text-lg font-medium gap-2 flex-col">
                        <img src={logo} className="h-8 w-8" />
                        Universus
                    </div>

                    <p className="text-sm text-muted-foreground flex items-center justify-center text-lg select-none">
                        <LoaderCircleIcon className="mr-2 h-4 w-4 animate-spin" />
                        {children}
                    </p>
                </div>
            </div>
        </div>
    )
}